import Vue from 'vue';

export default {

  SET_SEARCHTERM(state, searchTerm) {
    state.searchTerm = searchTerm
  },
  SET_CURRENT_SITE(state, selectedSite) {
    state.selectedSite = selectedSite
  },
  UNSET_CURRENT_SITE(state, selectedSite) {
    state.selectedSite = ''
  },
  SET_CURRENT_AREA(state, currentArea) {
    state.currentArea = currentArea
  },
  UNSET_CURRENT_AREA(state) {
    state.currentArea = null
  },
  SET_CURRENT_EQUIPMENT(state, currentEquipment) {
    state.currentEquipment = currentEquipment
  },
  UNSET_CURRENT_EQUIPMENT(state) {
    state.currentEquipment = null
  },
  SET_CURRENT_ENERGY_METER_NAMES(state, currentEnergyMeterNames) {
    state.currentEnergyMeterNames = currentEnergyMeterNames
  },
  SET_ALL_MEASURE_FILES_LOADED(state, allMeasureFilesLoaded) {
    state.allMeasureFilesLoaded = allMeasureFilesLoaded
  },
  SET_ALL_MEASURE_FILES_UIDS(state, allMeasureFilesUids) {
    state.allMeasureFilesUids = allMeasureFilesUids
  },
  SET_SELECTED_ITEM(state, uid) {
    state.selectedItem = uid;
  },
  SET_CURRENT_SIMULATION(state, simulation) {
    state.currentSimulation = simulation;
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js